(() => {
  'use strict';
  const observed = new WeakSet();
  const refresh = () => {
    if (window.Klarna?.OnsiteMessaging?.refresh) {
      window.Klarna.OnsiteMessaging.refresh();
    } else if (window.KlarnaOnsiteService?.push) {
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    }
  };
  const observe = () => {
    document.querySelectorAll('[data-nv-klarna] klarna-placement').forEach(placement => {
      if (observed.has(placement)) return;
      observed.add(placement);
      const update = () => {
        const rendered = placement.getBoundingClientRect().height > 8;
        placement.parentElement.classList.toggle('is-rendered', rendered);
      };
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(placement);
      update();
    });
  };
  document.addEventListener('nv:variant-change', event => {
    const { price, available } = event.detail;
    const container = document.querySelector('[data-nv-klarna-app], [data-nv-klarna="pdp"]');
    if (!container) return;
    container.hidden = !available;
    container.querySelectorAll('klarna-placement').forEach(placement => { placement.dataset.purchaseAmount = String(price); });
    refresh();
  });
  document.addEventListener('shopify:section:load', () => { observe(); refresh(); });
  window.addEventListener('load', () => { observe(); refresh(); });
  observe();
})();
